import { render, staticRenderFns } from "./EntityDetails.vue?vue&type=template&id=8d400272&scoped=true&"
import script from "./EntityDetails.vue?vue&type=script&lang=js&"
export * from "./EntityDetails.vue?vue&type=script&lang=js&"
import style0 from "./EntityDetails.vue?vue&type=style&index=0&id=8d400272&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d400272",
  null
  
)

export default component.exports